import { render, staticRenderFns } from "./checkXkgc.vue?vue&type=template&id=3287ea08&scoped=true&"
import script from "./checkXkgc.vue?vue&type=script&lang=js&"
export * from "./checkXkgc.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/reportEditor/reportEditor.less?vue&type=style&index=0&id=3287ea08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3287ea08",
  null
  
)

component.options.__file = "checkXkgc.vue"
export default component.exports